<app-main-header
  [menuData]="menu"></app-main-header>
<div class="container-fluid pt-4 px-0">
  <router-outlet />
</div>
@if (slideMenuService.showed) {
  <app-side-menu  
    [menuData]="menu">
  </app-side-menu>
}
